/** The distinct customer names of the Salesforce cases that link to a ticket, joined for display and sorting. */
export const customerNames = (ticket) => (
  [...new Set(ticket.cases.map((c) => c.customerName).filter(Boolean))].join(', ')
);
